$(document).ready(function(){

	$('.menu__link--dropdown').click(function(e){
		e.preventDefault();
		if (screen.width > 1024){
            $('.menu__dropdownList').fadeOut();
		}
		$(this).parent().find('.menu__dropdownList').fadeToggle('fast');
	});

	$('.menu').mouseleave(function(){
		$('.menu__dropdownList').fadeOut();
	})

	$('.menuButton').on('click', function(){
		$(this).toggleClass('active');
		$('.top').toggleClass('open');
		$('.menu').toggle();
		$('.top .service').toggle();
		$('.top__search').removeClass('active');
        $('.search').hide();
        $('html, body').toggleClass('overflow');
        $('.menu__list').scrollTop(0);
	});



	if (screen.width <= 1024){
		$('.page__menuHeader').on('click', function(){
			$(this).parent().find('.page__menuMobile').slideToggle();
			$(this).toggleClass('open');
		});

		$('.page__menuLink').on('click', function(){
			if (!$(this).hasClass('page__menuLink--dropdown')){
				$('.page__menuMobile').slideUp();
				$('.page__menuHeader').removeClass('open');
			}
		})
	}

});